import {createContext, useContext} from "react";
import Campaign from "@/campaigns/model/Campaign.ts";
import {CampaignRole} from "@/auth/User.ts";

export type CampaignContextValue = {
    campaign: Campaign;
    role: CampaignRole;
    isGameMaster: boolean;
    campaignPath: (path?: string) => string;
};

export const CampaignContext = createContext<CampaignContextValue | null>(null);

export function useCampaign(): CampaignContextValue {
    const value = useContext(CampaignContext);
    if (!value) throw new Error("useCampaign must be used within CampaignBoundary");
    return value;
}
